<template>
  <canvas v-show="ready" id="stays" ref="stays" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStyle } from "@coreui/coreui-pro/dist/js/coreui-utilities";

const brandPrimary = getStyle("--primary");
const brandSuccess = getStyle("--success");
const brandWarning = getStyle("--warning");
const brandDanger = getStyle("--danger");

// const CHART_COLORS = {
//   blue: brandPrimary,
//   green: brandSuccess,
//   yellow: brandWarning,
//   red: brandDanger
// };
const CHART_COLORS = {
  blue: "rgb(54, 162, 235)",
  green: "rgb(75, 192, 192)",
  yellow: "rgb(255, 205, 86)",
  red: "rgb(255, 99, 132)"
};

export default {
  props: ["client_customer", "product", "product_type"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Pallets",
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          borderWidth: 1,
          datalabels: {
            anchor: "center",
            align: "start",
            display: "auto",
            formatter: function (value, context) {
              return new Intl.NumberFormat("es-CL").format(value) + " Kg";
            }
          }
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/stock/stays?client_customer=${this.client_customer}&product=${this.product}&product_type=${this.product_type}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      // group array by range

      const rangeBlue = 3;
      const rangeGreen = 5;
      const rangeYellow = 7;
      const rangeRed = 15;

      const arrayLabels = [
        "0 - " + rangeBlue + " días",
        rangeBlue + " - " + rangeGreen + " días",
        rangeGreen + " - " + rangeYellow + " días",
        "> " + rangeYellow + " días"
      ];

      this.labels = arrayLabels;
      const datasetRed = [];
      const datasetYellow = [];
      const datasetGreen = [];
      const datasetBlue = [];

      for (let i in response.data.labels) {
        if (response.data.labels[i] > rangeRed) {
          datasetRed.push(response.data.dataset[i]);
        } else if (response.data.labels[i] > rangeYellow) {
          datasetYellow.push(response.data.dataset[i]);
        } else if (response.data.labels[i] > rangeGreen) {
          datasetGreen.push(response.data.dataset[i]);
        } else {
          datasetBlue.push(response.data.dataset[i]);
        }
      }

      this.data[0].data.push(datasetBlue.reduce((acc, value) => parseInt(value) + acc, 0));
      this.data[0].data.push(datasetGreen.reduce((acc, value) => parseInt(value) + acc, 0));
      this.data[0].data.push(datasetYellow.reduce((acc, value) => parseInt(value) + acc, 0));
      this.data[0].data.push(datasetRed.reduce((acc, value) => parseInt(value) + acc, 0));

      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    let ctx = this.$refs.stays.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "right"
          },
          datalabels: {
            color: "#043e73"
          },
          title: {
            display: true,
            align: "start",
            text: "Antiguedad de Stock"
          }
          // tooltip: {
          //   callbacks: {
          //     label: function (context) {
          //       return context.formattedValue + " Pallets";
          //     },
          //     afterBody: function (context) {
          //       console.log("context ", context);
          //       const index = context[0].dataIndex;
          //       return context[0].dataset.sum_boxes[0][index] + " Cajas";
          //     }
          //   }
          // }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
